import $ from 'jquery';

export default class MegaNavigation {
  constructor(component) {
    this.el = component.el;
    this.$el = $(this.el);

    this.navContainer = $('nav.full');
    this.nav = this.$el;
    this.trigger = this.nav.attr('id');
    this.megaNavWrap = this.nav.find('.mega-nav-wrap');
    this.navTrigger = ($(`[aria-controls=${this.trigger}]`));
    this.mainList = this.$el.find('.main-list');
    this.expandedList = this.$el.find('.expanded-list');
    this.categoriesList = this.$el.find('.category-list');
    this.backButton = this.$el.find('.back');

    // Add class for styling based on number of chosen lists
    let listCount = this.mainList.find('.list').length;
    if (listCount === 1) { listCount = 'one-col'; }
    if (listCount === 2) { listCount = 'two-col'; }
    if (listCount === 3) { listCount = 'three-col'; }
    this.mainList.find('.list').addClass(listCount);

    // Set mega-nav height
    this.nav.css({ height: this.megaNavWrap.height() });

    $(window).on('resize.mega-navigation', () => this.resize());
    $('.has-mega-nav, .mega-nav').on('mouseleave.mega-navigation', e => this.closeMegaNav(e));
    $('.show-more', this.el).on('click.mega-navigation', this.goDeepWithin.bind(this));
    $('.back', this.el).on('click.mega-navigation', this.reset.bind(this));
    $(document).on('toggleMegaNav.mega-navigation', this.toggle.bind(this));
    $(document).on('dismissMegaNav.mega-navigation', this.dismiss.bind(this));
  }

  resize() {
    this.nav.css({ height: this.megaNavWrap.height() });

    if ($(window).width() < 720) {
      this.dismiss();
    } else if (this.navTrigger.hasClass('active')) {
      this.invoke();
    }
  }

  toggle() {
    if (this.navTrigger.hasClass('active')) { this.dismiss(); } else { this.invoke(); }
  }

  invoke() {
    const offset = Math.floor((
      this.navContainer.position().top +
      this.navTrigger.position().top +
      this.navTrigger.outerHeight()
    ));
    this.navTrigger.addClass('active');
    this.nav.css('top', offset);
  }

  dismiss() {
    this.navTrigger.removeClass('active');
    this.nav.css('top', '-9999px');
    this.$el.trigger('closeMegaNav');
  }

  closeMegaNav(e) {
    if ($(e.currentTarget).hasClass('has-mega-nav')) {
      // leaving nav item
      if (!$(e.relatedTarget).hasClass('.mega-nav') && !$(e.relatedTarget).closest('.mega-nav').length) {
        this.dismiss();
      }
    } else if ($(e.currentTarget).hasClass('mega-nav')) {
      // leaving mega nav
      if (!$(e.currentTarget).hasClass('has-mega-nav') && !$(e.relatedTarget).parent().hasClass('has-mega-nav')) {
        this.dismiss();
      }
    }
  }

  goDeepWithin(e) {
    let target;
    let targetList;
    const link = ($(e.currentTarget));
    const origin = link.closest('ul.mega-nav-list');

    // //////////////////////////////////

    if (link.hasClass('show-more')) {
      const list = link.closest('ul.list-wrap').data('list');
      target = this.expandedList;
      targetList = target.find(`li[data-list='${list}']`);

      this.categoriesList.hide();
      this.expandedList.show().find('.list').removeClass('active');
      target.find('.back').data('target', 'main-list');
    }

    targetList.addClass('active');

    // //////////////////////////////////

    if (target.hasClass('expanded-list')) {
      target.find('.back').data('origin', 'expanded-list');
    } else {
      target.find('.back').data('origin', 'category-list');
    }

    // //////////////////////////////////

    const newHeight = target.height();
    if (newHeight > origin.height()) {
      this.nav.animate({ height: target.height() });
    }

    this.megaNavWrap.animate(
      { top: `-=${origin.height()}` },
      () => target.find('.back').fadeIn(150),
    );
  }

  reset(e) {
    const backButton = ($(e.currentTarget));
    const target = backButton.parents('.mega-nav').find(`.${backButton.data('target')}`);

    backButton.fadeOut(150);

    this.nav.animate({ height: target.height() });

    this.megaNavWrap.animate({ top: `+=${target.height()}` });

    if (backButton.data('origin') === 'category-list') {
      backButton.data('target', 'main-list');
      backButton.data('origin', 'expanded-list');
    }
  }

  unload() {
    $(window).off('resize.mega-navigation');
    $('.has-mega-nav, .mega-nav', this.el).off('mouseleave.mega-navigation');
    $('.show-more', this.el).off('click.mega-navigation');
    $('.back', this.el).off('click.mega-navigation');
    $(document).off('toggleMegaNav.mega-navigation');
    $(document).off('dismissMegaNav.mega-navigation');
  }
}
